import { render, staticRenderFns } from "./BasicJobInfoTableSection.vue?vue&type=template&id=739b0a1f&scoped=true&"
import script from "./BasicJobInfoTableSection.vue?vue&type=script&lang=js&"
export * from "./BasicJobInfoTableSection.vue?vue&type=script&lang=js&"
import style0 from "./BasicJobInfoTableSection.vue?vue&type=style&index=0&id=739b0a1f&prod&lang=css&"
import style1 from "./BasicJobInfoTableSection.vue?vue&type=style&index=1&id=739b0a1f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739b0a1f",
  null
  
)

export default component.exports